
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import workspaceAnalysisViewEditDialogDescriptor from './WorkspaceAnalysisViewEditDialogDescriptor.json'

export default defineComponent({
    name: 'workspace-analysis-edit-dialog',
    components: { Dialog },
    emits: ['close', 'save'],
    props: { visible: { type: Boolean }, propAnalysis: { type: Object } },
    data() {
        return {
            workspaceAnalysisViewEditDialogDescriptor,
            analysis: null as any,
            labelDirty: false
        }
    },
    computed: {
        labelHelp(): string {
            return (this.analysis.label?.length ?? '0') + ' / ' + workspaceAnalysisViewEditDialogDescriptor.labelMaxLength
        },
        nameHelp(): string {
            return (this.analysis.name?.length ?? '0') + ' / ' + workspaceAnalysisViewEditDialogDescriptor.nameMaxLength
        },
        descriptionHelp(): string {
            return (this.analysis.description?.length ?? '0') + ' / ' + workspaceAnalysisViewEditDialogDescriptor.descriptionMaxLength
        },
        saveButtonDisabled(): boolean {
            return this.analysis.label.length === 0 || this.analysis.name.length === 0
        }
    },
    watch: {
        propAnalysis() {
            this.loadAnalysis()
        }
    },
    created() {
        this.loadAnalysis()
    },
    methods: {
        loadAnalysis() {
            this.analysis = this.propAnalysis ? { ...this.propAnalysis } : {}
        },
        closeDialog() {
            this.analysis = { ...this.propAnalysis }
            this.$emit('close')
        },
        saveAnalysis() {
            this.$emit('save', this.analysis)
        }
    }
})
